<template>
	<div class="app-sidebar bg-white rounded-2 p-sm-1">
		<div class="sidebar-overlay" :class="{ 'sidebar-open': menuOpen }" @click="$store.commit('TOGGLE_MENU', false)"></div>
		<nav
			aria-label="HeyGov navigation"
			:class="{
				'sidebar-open': menuOpen,
				'sidebar-collapsed': sidebarCollapsed,
			}"
			@click="$store.commit('TOGGLE_MENU')"
		>
			<div class="logo text-center fixed-logo">
				<div class="logo-content" v-show="!sidebarCollapsed">
					<h3 class="logo-text">Town Web</h3>
					<p class="logo-text-sub">Mission Control v2</p>
				</div>
				<button
					class="sidebar-toggle-btn d-none d-md-block"
					@click.stop="$store.commit('TOGGLE_SIDEBAR_COLLAPSE')"
					:title="sidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'"
				>
					<font-awesome-icon :icon="['fas', sidebarCollapsed ? 'chevron-right' : 'chevron-left']" />
				</button>
			</div>
			<div class="scrollable-nav">
				<ul class="list-unstyled mb-0 py-3 pt-md-1">
					<li>
						<router-link class="btn text-start" :class="{ 'router-link-exact-active router-link-active': this.$route.path === '/' }" to="/">
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-house fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Home</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('CLIENT_ACCESS') && !sidebarCollapsed">
						<div class="sidebar-section-title">CRM</div>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('CLIENT_ACCESS')">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path === '/accounts2',
							}"
							to="/accounts2"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-table-layout fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Accounts (Beta)</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('CLIENT_ACCESS')">
						<router-link class="btn text-start px-3" :class="{ 'router-link-exact-active router-link-active': this.$route.path.includes('clients') }" to="/clients">
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-building-columns fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Clients</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && (authUser.email.includes('ivan@') || authUser.email.includes('cristina@') || authUser.email.includes('dustin@') || authUser.email.includes('angi@'))">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('ar-collections'),
							}"
							to="/ar-collections"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-file-invoice-dollar fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">AR Collections</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('CLIENT_CONTACT_ACCESS')">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('client-contacts'),
							}"
							to="/client-contacts"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-address-book fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Contacts</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('CLIENT_CONTACT_ACCESS') && authUser.email == 'srdjank90@gmail.com'">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('client-map'),
							}"
							to="/client-map"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-map-location-dot fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Map</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS') && !sidebarCollapsed">
						<div class="sidebar-section-title">Marketing Tools</div>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS')">
						<router-link class="btn text-start px-3" :class="{ 'router-link-exact-active router-link-active': this.$route.path.includes('marketing/utm') }" to="/marketing/utm">
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-chart-line fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">UTM &amp; Campaign Tracking</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS')">
						<router-link class="btn text-start px-3" :class="{ 'router-link-exact-active router-link-active': this.$route.path.includes('marketing/chris-willow') }" to="/marketing/chris-willow">
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-cookie-bite fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Chris Willow Tracking</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS')">
						<router-link class="btn text-start px-3" :class="{ 'router-link-exact-active router-link-active': this.$route.path.includes('marketing/brands') }" to="/marketing/brands">
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-buildings fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Brands</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS') && !sidebarCollapsed">
						<div class="sidebar-section-title">Business Intelligence</div>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS')">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active':
									this.$route.path.includes('municipalities') ||
									(this.$route.path.includes('contacts') &&
										!this.$route.path.includes('client') &&
										!this.$route.path.includes('county') &&
										!this.$route.path.includes('business')),
							}"
							to="/municipalities"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-city fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Municipalities</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS')">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('counties') || this.$route.path.includes('county-contacts'),
							}"
							to="/counties"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-map-pin fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Counties</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS')">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('business'),
							}"
							to="/businesses"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-briefcase fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Businesses</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('MUNICIPALITY_ACCESS') && competitorIntelligenceUrl">
						<!-- Standalone app (mc2-competitor-intelligence): opens in a new tab with the MC2 session
							handed over via URL fragment (#tok=), see its INTEGRATION.md, Option 1. -->
						<a
							class="btn text-start px-3"
							:href="competitorIntelligenceUrl"
							target="_blank"
							rel="noopener"
							title="Opens Competitor Intelligence in a new tab"
							@click.prevent="openCompetitorIntelligence"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-bullseye fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Competitor Intelligence</span>
								<i v-show="!sidebarCollapsed" class="far fa-external-link-alt ms-auto small opacity-50"></i>
							</div>
						</a>
					</li>

					<li class="" v-if="isAuth && !sidebarCollapsed">
						<div class="sidebar-section-title">Sales Tools</div>
					</li>

					<li v-if="isAuth">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.startsWith('/pricing'),
							}"
							to="/pricing"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-tags fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Pricing Engine (Beta)</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="!sidebarCollapsed">
						<div class="sidebar-section-title">LOB</div>
					</li>

					<li class="">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('campaigns') && !this.$route.path.includes('auto-campaigns'),
							}"
							to="/campaigns"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-envelope-open fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Campaigns</span>
							</div>
						</router-link>
					</li>

					<li class="">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('auto-campaigns'),
							}"
							to="/auto-campaigns"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-rocket fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Auto Campaigns</span>
							</div>
						</router-link>
					</li>

					<li class="">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('deliveries'),
							}"
							to="/deliveries"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-truck-fast fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Deliveries</span>
							</div>
						</router-link>
					</li>

					<li class="">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('lob-costs'),
							}"
							to="/lob-costs"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-chart-line-up fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Costs</span>
							</div>
						</router-link>
					</li>

					<li class="" v-if="isAuth && authUser.permissions.includes('CARNIVORE_ACCESS') && !sidebarCollapsed">
						<div class="sidebar-section-title">Data entry</div>
					</li>
					<li class="" v-if="isAuth && authUser.permissions.includes('CARNIVORE_ACCESS')">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('carnivores'),
							}"
							to="/carnivores"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-laptop-code fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Carnivores</span>
							</div>
						</router-link>
					</li>
					<li class="" v-if="isAuth && authUser.permissions.includes('CARNIVORE_ACCESS')">
						<a
							class="btn text-start px-3"
							href="https://file-bulk-download.townweb.workers.dev/"
							target="_blank"
							rel="noopener"
							title="Opens Bulk File Downloader in a new tab"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-file-arrow-down fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Bulk File Downloader</span>
								<i v-show="!sidebarCollapsed" class="far fa-external-link-alt ms-auto small opacity-50"></i>
							</div>
						</a>
					</li>

					<li
						class=""
						v-if="
							(isAuth && authUser.permissions.includes('SETTINGS_GENERAL_ACCESS') && authUser.email.includes('ivan')) ||
								authUser.email.includes('srdjank') ||
								(authUser.email.includes('marta') && !sidebarCollapsed)
						"
					>
						<div class="sidebar-section-title">Settings</div>
					</li>
					<li
						class=""
						v-if="
							(isAuth && authUser.permissions.includes('USER_ACCESS') && authUser.email.includes('ivan')) ||
								authUser.email.includes('srdjank') ||
								authUser.email.includes('marta') ||
								authUser.email.includes('cristina')
						"
					>
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('users'),
							}"
							to="/users"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-users fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Users</span>
							</div>
						</router-link>
					</li>
					<li
						class=""
						v-if="
							(isAuth && authUser.permissions.includes('SETTINGS_GENERAL_ACCESS') && authUser.email.includes('ivan')) ||
								authUser.email.includes('srdjank') ||
								authUser.email.includes('marko@') ||
								authUser.email.includes('marta')
						"
					>
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('settings'),
							}"
							to="/settings"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-gear fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Settings</span>
							</div>
						</router-link>
					</li>
					<li class="mb-2" v-if="isAuth && ((authUser.permissions.includes('MUNICIPALITY_UPDATE') && authUser.email.includes('ivan')) || authUser.email.includes('srdjank') || authUser.email.includes('marta'))">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('heygov-sync'),
							}"
							to="/heygov-sync"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-cloud-arrow-down fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">HeyGov Sync</span>
							</div>
						</router-link>
					</li>
					<li class="mb-2" v-if="isAuth && (authUser.email.includes('ivan') || authUser.email.includes('srdjank') || authUser.email.includes('marta'))">
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('activities'),
							}"
							to="/activities"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-magnifying-glass-chart fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Activities</span>
							</div>
						</router-link>
					</li>
					<li
						class=""
						v-if="
							(isAuth && authUser.email.includes('srdjank')) ||
								authUser.email.includes('marta') ||
								authUser.email.includes('jerrica') ||
								authUser.email.includes('flor') ||
								authUser.email.includes('aleksandra')
						"
					>
						<router-link
							class="btn text-start px-3"
							:class="{
								'router-link-exact-active router-link-active': this.$route.path.includes('time-trackings'),
							}"
							to="/time-trackings"
						>
							<div class="d-flex justify-content-start align-items-center">
								<i class="fa-duotone fa-clock fs-6 me-2"></i>
								<span v-show="!sidebarCollapsed">Time Trackings</span>
							</div>
						</router-link>
					</li>
				</ul>
				<div class="sidebar-project-links">
					<!-- Project "Juniper" -->
					<router-link class="btn btn-warning mb-3 w-100" :class="sidebarCollapsed ? 'fs-6' : 'fs-4'" to="/juniper">
						<span v-if="!sidebarCollapsed">CMS "Juniper"</span>
						<span v-else>J</span>
					</router-link>
					<!-- Project "Onboarding" -->
					<router-link
						class="btn btn-info mb-3 w-100"
						:class="sidebarCollapsed ? 'fs-6' : 'fs-4'"
						v-if="
							authUser.email.includes('srdjan') ||
								authUser.email.includes('marta@') ||
								authUser.email.includes('jerrica@') ||
								authUser.email.includes('ivan@') ||
								authUser.email.includes('marko@') ||
								authUser.email.includes('dustin@') ||
								authUser.email.includes('angi@') ||
								authUser.email.includes('sanja@') ||
								authUser.email.includes('cristina@') ||
								authUser.email.includes('aleksandra@')
						"
						to="/onboarding"
					>
						<span v-if="!sidebarCollapsed">Onboarding</span>
						<span v-else>O</span>
					</router-link>
					<!-- Project "KPI" -->
					<router-link
						class="btn btn-danger mb-3 w-100"
						:class="sidebarCollapsed ? 'fs-6' : 'fs-4'"
						v-if="
							authUser.email.includes('srdjan') ||
								authUser.email.includes('jerrica@') ||
								authUser.email.includes('ivan@') ||
								authUser.email.includes('dustin@') ||
								authUser.email.includes('aleksandra@') ||
								authUser.email.includes('cristina@')
						"
						to="/kpi"
					>
						<span v-if="!sidebarCollapsed">KPI</span>
						<span v-else>K</span>
					</router-link>
				</div>
				<div class="sidebar-bottom-tools">
					<div class="form-check form-switch sidebar-theme-toggle">
						<input class="form-check-input" id="dashboard-dark-switch" v-model="darkModeEnabled" type="checkbox" role="switch" />
						<label class="form-check-label ms-2" for="dashboard-dark-switch" v-show="!sidebarCollapsed">Dark mode</label>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	name: 'Sidebar',
	computed: {
		...mapState(['menuOpen', 'sidebarCollapsed', 'token', 'authUser']),
		...mapGetters(['isAuth']),
		competitorIntelligenceUrl() {
			return (process.env.VUE_APP_COMPETITOR_INTELLIGENCE_URL || '').replace(/\/+$/, '')
		},
		darkModeEnabled: {
			get() {
				return this.$store.state.dashboardDark
			},
			set(value) {
				this.$store.commit('SET_DASHBOARD_DARK', value)
			},
		},
	},
	methods: {
		openCompetitorIntelligence() {
			// JWT goes in the fragment, never the query string: fragments aren't sent to the
			// server, so they stay out of access logs and Referer headers. The CI app strips
			// it from the URL on arrival. Built here (not in :href) so the token isn't
			// visible on hover / copyable from the link.
			const base = this.competitorIntelligenceUrl
			if (!base) return
			const url = this.token ? `${base}/#tok=${encodeURIComponent(this.token)}` : `${base}/`
			window.open(url, '_blank', 'noopener')
		},
	},
}
</script>

<style lang="scss">
.app-sidebar {
	width: 265px;
	height: calc(100vh - 30px);
	margin: 15px;
	border-bottom: 15px solid transparent;
	overflow: hidden;
	position: fixed;
	z-index: 20;
	transition: width 0.3s ease;
	top: 0;
	left: 0;

	// Collapsed state
	&:has(.sidebar-collapsed) {
		width: 55px;
	}

	// Mobile responsive
	@media (max-width: 768px) {
		position: fixed;
		width: 75vw;
		transform: translateX(-100%);
		transition: transform 0.3s ease;
		margin: 0;
		height: 100vh;

		&:has(.sidebar-open) {
			transform: translateX(0);
		}

		&:has(.sidebar-collapsed) {
			width: 75vw;
		}
	}
}

.app-sidebar nav {
	z-index: 20;
	height: 100%;
	display: flex;
	flex-direction: column;
	transition: all 0.3s ease;

	&.sidebar-collapsed {
		.list-unstyled a {
			padding: 0.75rem 0.25rem !important;
			text-align: center;
			justify-content: center !important;
			margin: 0.25rem 0.1rem;
			border-radius: 8px;
			min-height: 40px;
			width: auto !important;

			.d-flex {
				justify-content: center !important;
				width: 100%;
				align-items: center;
			}

			i {
				margin-right: 0 !important;
				margin-left: 0 !important;
				font-size: 18px !important;
				line-height: 1;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.fixed-logo {
			justify-content: center;
			padding: 15px 5px;
		}

		.sidebar-toggle-btn {
			position: static !important;
			transform: none !important;
			margin: 0 auto;

			&:hover {
				transform: scale(1.1) !important;
			}

			&:active {
				transform: scale(0.95) !important;
			}
		}

		// Hide project buttons text, show only letters
		.btn-warning,
		.btn-info,
		.btn-danger {
			padding: 0.75rem 0.25rem !important;
			font-size: 18px !important;
			font-weight: 700 !important;
			min-height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0.25rem 0.1rem !important;
		}
	}

	.fixed-logo {
		flex-shrink: 0;
		border-bottom: 1px solid #e9ecef;
		margin-bottom: 10px;
		padding: 15px;
		background: white;
		position: sticky;
		top: 0;
		z-index: 10;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
	}

	.logo-content {
		flex: 1;
		text-align: center;
	}

	.logo-text {
		font-size: 28px;
		line-height: 16px;
		font-weight: 700;
		color: #cd1e32;
		margin: 0;
	}

	.logo-text-sub {
		font-size: 12px;
		letter-spacing: 1.2px;
		font-weight: 400;
		color: gray;
		margin: 0;
	}

	.sidebar-toggle-btn {
		background: white;
		border: 1px solid #495057;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		color: #495057;
		cursor: pointer;
		transition: all 0.2s ease;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
		position: absolute;
		transform: translateY(-50%);
		right: 3px;
		top: 15px;
		font-size: 12px;

		&:hover {
			background: rgba(205, 30, 50, 0.1);
			border-color: #495057;
			transform: translateY(-50%) scale(1.1);
		}

		svg {
			fill: currentColor;
		}
	}

	.scrollable-nav {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		overflow-y: auto;

		// Custom scrollbar styling - super thin and overlay
		// Webkit browsers (Chrome, Safari, Edge)
		&::-webkit-scrollbar {
			width: 3px;
		}

		&::-webkit-scrollbar-track {
			background: transparent;
		}

		&::-webkit-scrollbar-thumb {
			background: rgba(108, 117, 125, 0.3);
			border-radius: 2px;
			transition: background 0.3s ease;
		}

		&:hover::-webkit-scrollbar-thumb {
			background: rgba(108, 117, 125, 0.6);
		}

		&::-webkit-scrollbar-thumb:hover {
			background: rgba(108, 117, 125, 0.8);
		}

		.list-unstyled {
			padding: 10px;
		}

		.sidebar-project-links {
			padding: 0 10px;
		}

		.sidebar-bottom-tools {
			margin-top: auto;
			padding: 10px;
			border-top: 1px solid #e9ecef;
		}

		.sidebar-theme-toggle {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		// Firefox - hide scrollbar completely
		scrollbar-width: none;

		// For IE/Edge legacy
		-ms-overflow-style: none;
	}

	&.sidebar-collapsed {
		.scrollable-nav .list-unstyled {
			padding: 0px;
		}

		.scrollable-nav .sidebar-project-links {
			padding: 0px;
		}

		.scrollable-nav .sidebar-bottom-tools {
			padding: 10px 5px;
		}

		.scrollable-nav .sidebar-theme-toggle {
			justify-content: center;
		}
	}

	.logo {
		border-bottom: 1px solid #e9ecef;
		margin-bottom: 10px;
		padding-bottom: 5px;
	}

	.logo-text {
		font-size: 28px;
		line-height: 16px;
		font-weight: 700;
		color: #cd1e32;
		margin: 0;
	}

	.logo-text-sub {
		font-size: 12px;
		letter-spacing: 1.2px;
		font-weight: 400;
		color: gray;
		margin: 0;
	}

	.sidebar-brand {
		padding-top: 10px;
		margin-bottom: 1.5rem;
		display: block;
		img {
			margin-top: 6px;
		}
		p {
			font-weight: bold;
			font-size: 14px;
			line-height: 16px;
			margin-bottom: 0;
		}
		h3 {
			font-weight: 600;
			font-size: 20px;
			line-height: 23px;
			color: #2b2b2e;
		}
		&:hover {
			text-decoration: none;
		}
	}
	.list-unstyled {
		li {
			a {
				color: var(--bs-gray);
				display: block;
				transition: all 0.2s ease;

				&:hover {
					background-color: #f0f0f0;
				}
				&.router-link-exact-active {
					background-color: var(--bs-primary);
					color: #fff;
					box-shadow: 0 0.125rem 0.25rem rgba(black, 0.075);
				}

				.d-flex {
					align-items: center;

					i {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 20px;
						height: 20px;
					}
				}
			}
		}
	}
	.bottom-nav {
		bottom: 0;
	}

	.sidebar-section-title {
		font-size: 12px;
		color: #6c757d;
		font-weight: 500;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		padding: 8px 16px 4px 16px;
		margin: 8px 0 4px 0;
	}
}
@media (max-width: 767.98px) {
	.sidebar-overlay {
		content: '';
		position: fixed;
		z-index: 115;
		transition: background-color 0.2s ease-out;
		top: 0;
		left: 0;
		&.sidebar-open {
			bottom: 0;
			right: 0;
			background-color: rgba(0, 0, 0, 0.2);
			backdrop-filter: blur(5px);
		}
	}

	.app-sidebar {
		width: 75vw !important;
		transform: translateX(-100%);
		transition: transform 0.3s ease;

		&:has(.sidebar-open) {
			transform: translateX(0);
		}

		// Hide toggle button on mobile
		.sidebar-toggle-btn {
			display: none !important;
		}

		nav {
			padding: 1rem;

			&.sidebar-open {
				// Mobile sidebar is always expanded when open
				.list-unstyled a {
					padding: 0.75rem 1rem !important;
					text-align: left !important;
					justify-content: flex-start !important;
					margin: 0.25rem 0 !important;

					.d-flex {
						justify-content: flex-start !important;
					}

					i {
						margin-right: 0.5rem !important;
						font-size: 16px !important;
					}
				}
			}

			// Override collapsed styles on mobile
			&.sidebar-collapsed {
				.list-unstyled a {
					padding: 0.75rem 1rem !important;
					text-align: left !important;
					justify-content: flex-start !important;

					.d-flex {
						justify-content: flex-start !important;
					}

					i {
						margin-right: 0.5rem !important;
						font-size: 16px !important;
					}
				}

				.fixed-logo {
					justify-content: space-between !important;
					padding: 10px 15px !important;
				}
			}
		}
	}
}
.app-ios .app-sidebar nav {
	padding-top: 2rem !important;
}
</style>
